module.exports = __webpack_public_path__ + "img/d74755f.jpg";